<template lang="pug">
  v-img(:src="footerUrl" contain max-height="50px" :position="position")
    template(v-slot:placeholder)
      v-row(class="fill-height ma-0" align="center" justify="center")
        v-progress-circular(indeterminate color="grey")
</template>

<script>
export default {
  props: {
    footerUrl: {
      type: String,
      default: null
    },
    footerAlignment: {
      type: Number,
      default: 1
    },
  },
  computed: {
    position() {
      switch (this.footerAlignment) {
        case 0:
          return 'center left'

        case 1:
          return 'center center'

        case 2:
          return 'center right'
      
        default:
          return null
      }
    }
  },
}
</script>

<style lang="scss" scoped>
</style>